import type { SelectableItem, SittingBreaksId } from '@physitrack/championhealth-types';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ActivitySlider } from '../questions/activitySlider/ActivitySlider';
import { CheckboxRadio } from '../questions/checkboxRadio/CheckboxRadio';
import { DotRadio } from '../questions/dotRadio/DotRadio';
import { HourSelect } from '../questions/hourSelect/HourSelect';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function PhysicalActivity1({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem) {
  const [showBreaks, setShowBreaks] = useState(false);
  const { t } = useTranslation();

  const sittingBreaksOptions: SelectableItem<SittingBreaksId>[] = [
    { id: '30mins', title: t('PA001') },
    { id: '1hour', title: t('PA002') },
    { id: '2hours', title: t('PA003') },
    { id: '3hours', title: t('PA004') },
  ];

  useEffect(() => {
    if (assessmentValues?.hours_sitting) {
      if (assessmentValues.hours_sitting === 'wheelchair') {
        setShowBreaks(false);
        onSetValue({ id: 'sitting_breaks', value: null });
      } else {
        const hours = assessmentValues.hours_sitting.split(':')[0];
        if (Number(hours) > 0) {
          setShowBreaks(true);
        } else {
          setShowBreaks(false);
          onSetValue({ id: 'sitting_breaks', value: null });
        }
      }
    }
  }, [assessmentValues?.hours_sitting]);

  useEffect(() => {
    if (!assessmentValues.activity) {
      onSetValue({
        id: 'activity',
        value: {
          percent: '0.00',
          textValue: '0mins',
          value: '0',
        },
      });
    }
  }, []);

  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <ActivitySlider
        questionid="activity"
        width="_wide"
        questionTitle={t('assessment.question.activity')}
        leftlabel={t('PA006')}
        rightlabel={t('PA007')}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('PA008')}
        onOpenModal={onOpenModal}
      />

      <DotRadio
        questionid="resistence_strength"
        range="8"
        width=""
        questionTitle={t('assessment.question.resistence_strength')}
        type="question"
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('PA010')}
        onOpenModal={onOpenModal}
      />
      <DotRadio
        questionid="stretch"
        range="8"
        width=""
        questionTitle={t('assessment.question.stretch')}
        type="question"
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('PA012')}
        onOpenModal={onOpenModal}
      />
      <HourSelect
        questionid="hours_sitting"
        questionTitle={t('assessment.question.hours_sitting')}
        hourSuffix={t('A122')}
        minuteSuffix={t('A120')}
        width=""
        skipText={t('PA014')}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('PA015')}
        onOpenModal={onOpenModal}
      />
      {showBreaks && (
        <CheckboxRadio
          questionid="sitting_breaks"
          width=""
          options={sittingBreaksOptions}
          questionTitle={t('assessment.question.sitting_breaks')}
          onSetValue={onSetValue}
          assessmentValues={assessmentValues}
          fadeIn="yes"
        />
      )}
    </div>
  );
}
